<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :api-getlist='getList'
          ref='table'
          :config="config"
          hide-upsert>
        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_list.js'
import { getRequestList } from '@/api/request'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
    }
  },
  watch: {
    protocol () {
      this.$refs.table.getData(true)
    }
  },
  computed: {
    ...mapState('app', ['protocol']),
    // filters () {
    //   if (this.protocol_id !== -1) {
    //     console.error('il filter')
    //     return { protocol_id: this.protocol_id }
    //   }
    //   return { protocol_id: undefined }
    // }
  },
  methods: {
    getList (entity, filters, pagination) {
      if (this.protocol.id !== -1) {
        filters.protocol_id = this.protocol.id
      }
      return getRequestList('request', filters, pagination)
    }
  }
}
</script>
